export default Object.freeze({
  AddUnit: 'ADD-UNIT',
  DropUnit: 'DROP-UNIT',
  Enrolment: 'ENROLMENT',
  Variation: 'VARIATION',
})
